/** @jsxImportSource @emotion/react */

import { useTheme } from '../../ThemeProvider';
import { Input, BaseProps } from '../Input';

export type Props = Omit<BaseProps, 'type' | 'icon' | 'label'>;

export const SearchInput = ({ placeholder, ...props }: Props) => {
  const { spacing } = useTheme();
  return (
    <Input
      {...props}
      icon="search"
      placeholder={placeholder ?? 'Search'}
      type="text"
      css={{
        '.MuiOutlinedInput-root': {
          input: {
            padding: `${spacing.xxxs} ${spacing.xxxs} ${spacing.xxxs} 0px`,
          },
        },
      }}
    />
  );
};
